import { motion } from "framer-motion";
import { Reveal } from "@/components/Kinetic";

const WORDS = [
  { t: "SUBLIMATION", x: "4%", y: "12%", s: "text-3xl sm:text-5xl", c: "text-white/25" },
  { t: "AIRBRUSH", x: "68%", y: "8%", s: "text-4xl sm:text-6xl", c: "text-white/15" },
  { t: "SCRIPT", x: "12%", y: "38%", s: "text-5xl sm:text-7xl", c: "text-outline" },
  { t: "EMBROIDERY", x: "60%", y: "34%", s: "text-2xl sm:text-4xl", c: "text-white/30" },
  { t: "FLEECE 450GSM", x: "6%", y: "62%", s: "text-xl sm:text-3xl", c: "text-white/20" },
  { t: "DYE-SUB", x: "74%", y: "58%", s: "text-3xl sm:text-5xl", c: "text-outline-pink" },
  { t: "CUSTOM BLANKS", x: "16%", y: "82%", s: "text-2xl sm:text-4xl", c: "text-white/15" },
  { t: "NEON NIGHTS", x: "66%", y: "80%", s: "text-2xl sm:text-4xl", c: "text-white/25" },
  { t: "ONE OF ONE", x: "42%", y: "10%", s: "text-xl sm:text-2xl", c: "text-[#ff1053]/60" },
  { t: "THREADWORK", x: "44%", y: "88%", s: "text-xl sm:text-3xl", c: "text-white/20" },
];

const DotRing = () => {
  const dots = Array.from({ length: 26 });
  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none" aria-hidden="true">
      <div className="relative w-[19rem] h-[19rem] sm:w-[24rem] sm:h-[24rem] animate-[spin_26s_linear_infinite]">
        {dots.map((_, i) => (
          <span
            key={i}
            className="absolute w-2 h-2 sm:w-2.5 sm:h-2.5 rounded-full bg-white/70"
            style={{
              top: "50%",
              left: "50%",
              transform: `translate(-50%, -50%) rotate(${i * (360 / 26)}deg) translateX(9.5rem)`,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default function KeywordField() {
  return (
    <section id="keywords" className="relative h-[85vh] min-h-[560px] overflow-hidden border-b border-white/10">
      <Reveal className="absolute top-8 left-1/2 -translate-x-1/2 z-10">
        <p className="text-[10px] tracking-[0.14em] text-white/50">( Every thread placed with intent )</p>
      </Reveal>

      {WORDS.map((w, i) => (
        <motion.span
          key={w.t}
          className={`absolute font-display font-medium uppercase whitespace-nowrap select-none ${w.s} ${w.c}`}
          style={{ left: w.x, top: w.y }}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, delay: i * 0.07 }}
        >
          <motion.span
            className="block"
            animate={{ y: [0, -(6 + (i % 4) * 3), 0] }}
            transition={{ repeat: Infinity, duration: 5 + (i % 5), ease: "easeInOut" }}
          >
            {w.t}
          </motion.span>
        </motion.span>
      ))}

      <div className="absolute inset-0 flex items-center justify-center">
        <DotRing />
        <Reveal>
          <div className="relative">
            <div className="absolute inset-0 neon-glow-pink blur-3xl scale-125" aria-hidden="true" />
            <img
              src="/assets/logo-alpha.png"
              alt="Always & Forever embroidered script mark"
              className="relative w-56 sm:w-72 object-contain drop-shadow-[0_0_35px_rgba(255,255,255,0.25)]"
            />
          </div>
        </Reveal>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[10px] uppercase tracking-[0.3em] text-white/35">
        The Language of the Brand
      </div>
    </section>
  );
}
